import {
  FinchConnectionDetailFragment,
  FinchConnectionStatus,
  OrganizationDetailFragment,
} from '@alice-financial/alice-sdk'

// Helper function to determine if a Finch connection is "done" (should be shown as connected)
export const isDoneFinchConnection = (connection: FinchConnectionDetailFragment): boolean => {
  // Connection is done if EITHER:
  // 1. isActive is true (legacy logic), OR
  // 2. status is "authenticated", OR
  // 3. status is "reviewed_enabled"
  return (
    connection.isActive ||
    connection.status === FinchConnectionStatus.Authenticated ||
    connection.status === FinchConnectionStatus.ReviewedEnabled
  )
}

export const isDisplayableConnection = (connection: FinchConnectionDetailFragment): boolean => {
  return connection.status !== FinchConnectionStatus.ReviewedDisabled
}

export const isUnauthenticatedFinchConnection = (connection: FinchConnectionDetailFragment): boolean => {
  return connection.status === FinchConnectionStatus.NeedsAuthentication && !connection.isActive
}

export const getFinchConnections = (
  org: OrganizationDetailFragment | null | undefined
): {
  all: FinchConnectionDetailFragment[]
  visible: FinchConnectionDetailFragment[]
  connected: FinchConnectionDetailFragment[]
  needAuth: FinchConnectionDetailFragment[]
} => {
  const allFinchConnections: FinchConnectionDetailFragment[] = org?.payrollConnection?.finchConnections || []

  // Filter out connections that should not be shown in UI (reviewed_disabled)
  const visibleFinchConnections = allFinchConnections.filter(isDisplayableConnection)

  // Separate connections into "done" (connected) and those needing authentication
  const doneFinchConnections = visibleFinchConnections.filter(isDoneFinchConnection)
  const needingAuthFinchConnections = visibleFinchConnections.filter(isUnauthenticatedFinchConnection)

  return {
    all: allFinchConnections,
    visible: visibleFinchConnections,
    connected: doneFinchConnections,
    needAuth: needingAuthFinchConnections,
  }
}
